import { render, staticRenderFns } from "./DesktopSearchVilla.vue?vue&type=template&id=85cc7f74&"
import script from "./DesktopSearchVilla.vue?vue&type=script&lang=js&"
export * from "./DesktopSearchVilla.vue?vue&type=script&lang=js&"
import style0 from "./DesktopSearchVilla.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports